import {InitialRequestUrl} from "@khan/shared-core";

/**
 * Selector functions to find all relevant links on Unit, Course, and Lesson pages.
 */

export async function findLinksInCourseOrUnitPage(): Promise<Array<string>> {
    await waitForElement("#topic-progress");
    const nodeList = document.querySelectorAll("#topic-progress a");
    return nodeListToLinkArray(nodeList);
}

export function findLinksInLessonPage(): Array<string> {
    const nodeList = document.querySelectorAll(
        "[data-testid='learnable-content-cells'] a",
    );
    return nodeListToLinkArray(nodeList);
}

export interface ValidContentLocation {
    id: string;
    defaultUrlPath: string;
    translatedTitle: string;
}

export function isValidContentLocation(obj: any): obj is ValidContentLocation {
    return !!obj && !!obj.id && !!obj.defaultUrlPath && !!obj.translatedTitle;
}

export function makeLinksFromGQLObjects(
    objects: Array<ValidContentLocation>,
): Array<string> {
    const baseUrl = InitialRequestUrl.origin;

    const links: string[] = [];
    for (const obj of objects) {
        links.push(
            formatLinkForKhanmigo({
                linkText: obj.translatedTitle,
                linkUrl: baseUrl.concat(obj.defaultUrlPath),
            }),
        );
    }
    return links;
}

// @ts-expect-error - TS2315 - Type 'NodeList' is not generic.
function nodeListToLinkArray(nodeList: NodeList<any>): Array<string> {
    const baseUrl = InitialRequestUrl.hostname;
    const links: string[] = [];
    for (const node of nodeList) {
        const linkText = node.innerText.split("\n")[0];
        const linkUrl = node.href.replace("www.khanacademy.org", baseUrl);
        links.push(formatLinkForKhanmigo({linkText, linkUrl}));
    }
    return links;
}

function formatLinkForKhanmigo({
    linkText,
    linkUrl,
}: {
    linkText: string;
    linkUrl: string;
}): string {
    return `${linkText} is a topic covered by this link: ${linkUrl}`;
}

// https://stackoverflow.com/a/61511955/3084820
function waitForElement(selector: string) {
    return new Promise((resolve) => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver((_: unknown) => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        document.body &&
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
    });
}
